

import { Component, Prop, Vue } from 'nuxt-property-decorator'
import HeaderDekraLogo from './header/HeaderDekraLogo.vue'
import BasePicture from './base/BasePicture.vue'
import BaseButton from './base/BaseButton.vue'
import IImage from '../shared/general/interfaces/IImage'
import { resolutions } from '../shared/general/services/LandingPageService'
import { trackCta } from '../shared/general/tracking/TrackingService'
import { ILink } from '../shared/general/interfaces/ILink'

@Component({
  name: 'LandingPageHeader',
  methods: { trackCta },
  components: {
    HeaderDekraLogo,
    BasePicture,
    BaseButton,
  },
})
export default class LandingPageHeader extends Vue {
  @Prop() logo2 ?: IImage

  @Prop() logo3 ?: IImage

  @Prop({ required: true }) campaignCta! : ILink

  private showCampaignCta = false

  private readonly resolutions : Record<number | 'max', string> = resolutions

  $refs! : {
    ctaButton ?: HTMLElement
    logoContainer ?: HTMLElement
    landingPageHeader ?: HTMLElement
  }

  mounted () {
    if (!this.logo2 && !this.logo3) {
      this.campaignCtaVisibility()
    }
    window.addEventListener('resize', this.campaignCtaVisibility)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.campaignCtaVisibility)
  }

  public campaignCtaVisibility () : void {
    const { logoContainer, ctaButton } = this.$refs
    if (!logoContainer || !ctaButton) return

    const logoRect = logoContainer.getBoundingClientRect()
    const buttonRect = ctaButton.getBoundingClientRect()

    this.showCampaignCta = Math.trunc(logoRect.right) < Math.trunc(buttonRect.left)
  }

  private clickCampaignCta () : void {
    if (!this.$refs.landingPageHeader) return
    trackCta(this.$refs.landingPageHeader, {
      cta_type: 'cta_lp_header',
      icon_name: this.campaignCta.iconName || '',
      link_text: this.campaignCta.label || '',
      link_url: this.campaignCta.url || '',
    })
  }
}
